import {gtmEvent, segment} from './helpers'
import {TRANSACTION_TYPE_BUY, TRANSACTION_TYPE_RENT} from '../const'

/**
 * Tracks when a user clicks the main call to action button on the Event Summary
 * page that will take them to the next step in the process.
 *
 * @param {String} selectedBaseTransactionType The transaction type of the base suit/tux
 * @param {Boolean} isError Whether or not the click displayed an error
 */
export const clickedEventSummaryCTA = (selectedBaseTransactionType, isError) => {
  segment('Clicked Participant Summary CTA', {selectedBaseTransactionType, isError})
  gtmEvent('clickedEventSummaryCTA')
}

export const clickedEventSummaryLink = (targetLinkName) =>
  segment('Clicked Participant Summary Link', {targetLinkName})

export const clickedEventSummaryTransactionOption = (productCategory, name, clickedType) => {
  segment('Clicked Participant Summary Transaction Option', {
    productCategory,
    name,
    transactionType: {
      [TRANSACTION_TYPE_BUY]: 'Buy New',
      [TRANSACTION_TYPE_RENT]: 'Rent',
    }[clickedType],
  })
}

export const viewedEventSummaryPage = (isPaid, defaultBaseTransactionType) =>
  segment('Viewed Participant Summary Page', {isPaid, defaultBaseTransactionType})
